// Activity Type Permissions
export const CreateActivityTypesPermission = 'CreateActivityTypes'
export const ViewActivityTypesPermission = 'ViewActivityTypes'
export const EditActivityTypesPermission = 'EditActivityTypes'
export const DeleteActivityTypesPermission = 'DeleteActivityTypes'

// Attendee Permissions
export const ViewAttendeesPermission = 'ViewAttendees'
export const CreateAttendeesPermission = 'CreateAttendees'
export const EditAttendeesPermission = 'UpdateAttendees'
export const DeleteAttendeesPermission = 'DeleteAttendees'
export const ImportAttendeesPermission = 'ImportAttendees'
export const ExportLOAPermission = 'ExportLOA'

// Division Permissions
export const CreateDivisionsPermission = 'CreateDivisions'
export const ViewDivisionsPermission = 'ViewDivisions'
export const EditDivisionsPermission = 'EditDivisions'
export const DeleteDivisionsPermission = 'DeleteDivisions'

// Event Permissions
export const CreateEventsPermission = 'CreateEvents'
export const ViewEventsPermission = 'ViewEvents'
export const EditEventsPermission = 'EditEvents'
export const DeleteEventsPermission = 'DeleteEvents'

// Event Type Permissions
export const CreateEventTypesPermission = 'CreateEventTypes'
export const ViewEventTypesPermission = 'ViewEventTypes'
export const EditEventTypesPermission = 'EditEventTypes'
export const DeleteEventTypesPermission = 'DeleteEventTypes'

// External Source Permissions
export const CreateExternalSourcesPermission = 'CreateExternalSources'
export const ViewExternalSourcesPermission = 'ViewExternalSources'
export const EditExternalSourcesPermission = 'EditExternalSources'
export const DeleteExternalSourcesPermission = 'DeleteExternalSources'

// HCP Master Data Permissions
export const CreateHCPMasterDataPermission = 'CreateHCPMasterData'
export const ViewHCPMasterDataPermission = 'ViewHCPMasterData'
export const EditHCPMasterDataPermission = 'EditHCPMasterData'
export const DeleteHCPMasterDataPermission = 'DeleteHCPMasterData'

// Organization Permissions
export const CreateOrganizationsPermission = 'CreateOrganizations'
export const ViewOrganizationsPermission = 'ViewOrganizations'
export const EditOrganizationsPermission = 'EditOrganizations'
export const DeleteOrganizationsPermission = 'DeleteOrganizations'

// Relationship Permissions
export const CreateRelationshipsPermission = 'CreateRelationships'
export const ViewRelationshipsPermission = 'ViewRelationships'
export const EditRelationshipsPermission = 'EditRelationships'
export const DeleteRelationshipsPermission = 'DeleteRelationships'

// Role Permissions
export const CreateRolesPermission = 'CreateRoles'
export const ViewRolesPermission = 'ViewRoles'
export const EditRolesPermission = 'EditRoles'
export const DeleteRolesPermission = 'DeleteRoles'

// Spend Type Permissions
export const CreateSpendTypesPermission = 'CreateSpendTypes'
export const ViewSpendTypesPermission = 'ViewSpendTypes'
export const EditSpendTypesPermission = 'EditSpendTypes'
export const DeleteSpendTypesPermission = 'DeleteSpendTypes'

// Team Permissions
export const CreateTeamsPermission = 'CreateTeams'
export const ViewTeamsPermission = 'ViewTeams'
export const EditTeamsPermission = 'EditTeams'
export const DeleteTeamsPermission = 'DeleteTeams'

// ExportTOV Permissions
export const ExportTOVPermission = 'ExportTOV'
export const ExportEventsPermission = 'ExportEvents'

// User Permissions
export const CreateUsersPermission = 'CreateUsers'
export const ViewUsersPermission = 'ViewUsers'
export const EditUsersPermission = 'EditUsers'
export const ImportUsersPermission = 'ImportUsers'
export const UnblockUsersPermission = 'UnblockUser'
export const BlockUsersPermission = 'BlockUser'

// Team Overview Permissions
export const ViewTeamOverview = 'ViewTeamOverview'

//  Countries Permissions
export const ViewCountriesPermission = 'ViewCountries'
export const EditCountriesPermission = 'EditCountries'
export const DeleteCountriesPermission = 'DeleteCountries'
export const CreateCountriesPermission = 'CreateCountries'

//  Cities Permissions
export const ViewCitiesPermission = 'ViewCities'
export const EditCitiesPermission = 'EditCities'
export const DeleteCitiesPermission = 'DeleteCities'
export const CreateCitiesPermission = 'CreateCities'

//  Brands Permissions
export const ViewBrandsPermission = 'ViewBrands'
export const EditBrandsPermission = 'EditBrands'
export const DeleteBrandsPermission = 'DeleteBrands'
export const CreateBrandsPermission = 'CreateBrands'

